var exports = {
  "k": "x43aef4ae--205a93--container",
};

module.exports = exports;
